import {
  Button,
  IconButton,
  InputAdornment,
  Tab,
  Tabs,
  TextField,
} from "@mui/material";
import { Box } from "@mui/system";
import { useState } from "react";
import Clientes from "./clientes";
import {
  Add,
  Clear,
  FilterAltOutlined,
  PersonAddAlt1Outlined,
  Search,
} from "@mui/icons-material";
import useStyles from "./styles";
import { useTheme } from "@emotion/react";
import FilterBar from "../../../../components/topBarFilter";
import VirtualizedAutocomplete from "../../../../components/virtualization/virtualizedAutocomplete";
import {
  CampoCliente,
  renderOpcaoCliente,
} from "../../../../components/opcaoCliente";
import { getClienteOptionLabel } from "../../../../components/grupoEconomico/helpers";
import Staff from "./staff";

export default function Usuarios() {
  const theme = useTheme();
  const styles = useStyles(theme);
  const [value, setValue] = useState(0);
  const [openFilterEquipe, setOpenFilterEquipe] = useState(false);
  const [openFilterClient, setOpenFilterClient] = useState(false);
  const [buscarUsuarioEquipe, setBuscarUsuarioEquipe] = useState("");
  const [buscarUsuarioClient, setBuscarUsuarioClient] = useState("");
  // Guarda o id do cliente escolhido no filtro — é a chave usada pela aba de
  // clientes para filtrar as linhas.
  const [selectCliente, setSelectCliente] = useState("");
  const [openModalAddUserEquipe, setOpenModalAddUserEquipe] = useState(false);
  const [openModalAddUserClient, setOpenModalAddUserClient] = useState(false);
  const [allClientes, setAllClientes] = useState([]);
  // O filtro guarda só o id (é o que a aba de clientes usa para filtrar as
  // linhas); o objeto do cliente fica aqui porque o campo precisa dele para
  // montar o selo PF/PJ.
  const [clienteSelecionado, setClienteSelecionado] = useState(null);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const actionsEquipe = [
    {
      icon: <FilterAltOutlined />,
      name: "Filtro",
      onClick: () => setOpenFilterEquipe(true),
    },
    {
      icon: <PersonAddAlt1Outlined />,
      name: "Novo Usuário",
      onClick: () => setOpenModalAddUserEquipe(true),
    },
  ];

  const actionsClient = [
    {
      icon: <FilterAltOutlined />,
      name: "Filtro",
      onClick: () => setOpenFilterClient(true),
    },
    {
      icon: <PersonAddAlt1Outlined />,
      name: "Novo Usuário Cliente",
      onClick: () => setOpenModalAddUserClient(true),
    },
  ];

  return (
    <Box>
      {value === 0 && (
        <FilterBar
          actions={actionsEquipe}
          openFilter={openFilterEquipe}
          setOpenFilter={setOpenFilterEquipe}
          selectorComponentLeft={
            <TextField
              variant="outlined"
              label="Buscar usuário"
              value={buscarUsuarioEquipe}
              size="small"
              onChange={(event) => {
                setBuscarUsuarioEquipe(event.target.value);
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search />
                  </InputAdornment>
                ),
                endAdornment: buscarUsuarioEquipe ? (
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setBuscarUsuarioEquipe("")}
                      edge="end"
                    >
                      <Clear />
                    </IconButton>
                  </InputAdornment>
                ) : null,
              }}
              sx={styles.searcField}
            />
          }
          selectorComponentRight={
            <Button
              endIcon={<Add sx={styles.containerAdd} />}
              onClick={() => setOpenModalAddUserEquipe(true)}
              sx={styles.buttomAddUser}
              variant="outlined"
            >
              Novo Usuário
            </Button>
          }
        />
      )}
      {value === 1 && (
        <FilterBar
          actions={actionsClient}
          openFilter={openFilterClient}
          setOpenFilter={setOpenFilterClient}
          selectorComponentLeft={
            <Box sx={{ display: "flex", gap: 1, width: "100%" }}>
              <TextField
                variant="outlined"
                label="Buscar usuário"
                value={buscarUsuarioClient}
                size="small"
                onChange={(event) => {
                  setBuscarUsuarioClient(event.target.value);
                }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                  endAdornment: buscarUsuarioClient ? (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setBuscarUsuarioClient("")}
                        edge="end"
                      >
                        <Clear />
                      </IconButton>
                    </InputAdornment>
                  ) : null,
                }}
                sx={styles.searcField}
              />
              <VirtualizedAutocomplete
                size="small"
                disablePortal
                options={allClientes}
                value={clienteSelecionado}
                getOptionLabel={(option) =>
                  getClienteOptionLabel(option)
                }
                sx={styles.clientAutocomplete}
                onChange={(event, cliente) => {
                  setClienteSelecionado(cliente || null);
                  setSelectCliente(cliente?.id || "");
                }}
                renderOption={renderOpcaoCliente()}
                renderInput={(params) => (
                  <CampoCliente
                    params={params}
                    option={clienteSelecionado}
                    label="Cliente"
                  />
                )}
              />
            </Box>
          }
          selectorComponentRight={
            <Button
              endIcon={<Add sx={styles.containerAdd} />}
              onClick={() => setOpenModalAddUserClient(true)}
              sx={styles.buttomAddUser}
              variant="outlined"
            >
              Novo Usuário
            </Button>
          }
        />
      )}
      <Tabs
        value={value}
        onChange={handleChange}
        sx={{ mb: "10px" }}
        variant="scrollable"
        scrollButtons="auto"
        aria-label="scrollable tabs"
        allowScrollButtonsMobile
      >
        <Tab label="Equipe interna" />
        <Tab label="Clientes" />
      </Tabs>

      {value === 0 && (
        <>
          <Staff
            openFilter={openFilterEquipe}
            setOpenFilter={setOpenFilterEquipe}
            buscarUsuario={buscarUsuarioEquipe}
            setBuscarUsuario={setBuscarUsuarioEquipe}
            setOpenModalAddUser={setOpenModalAddUserEquipe}
            openModalAddUser={openModalAddUserEquipe}
          />
        </>
      )}
      {value === 1 && (
        <Clientes
          openFilter={openFilterClient}
          setOpenFilter={setOpenFilterClient}
          buscarUsuario={buscarUsuarioClient}
          setBuscarUsuario={setBuscarUsuarioClient}
          setOpenModalAddUser={setOpenModalAddUserClient}
          openModalAddUser={openModalAddUserClient}
          setAllClientes={setAllClientes}
          allClientes={allClientes}
          setSelectCliente={setSelectCliente}
          selectCliente={selectCliente}
        />
      )}
    </Box>
  );
}
